var vmg;
var imgGallery = [];
$(document).ready(function () {
  if ($("#vue-gallery").length) {
    $(".post img").each(function (index) {
      if (
        $(this).parents(".relatedNews").length == 0 &&
        $(this).parents(".relatedOpinions").length == 0 &&
        $(this).parents(".ad").length == 0 &&
        $(this).parents(".maslr").length == 0
      ) {
        $(this)
          .parent()
          .addClass("openGallery");
        imgGallery.push({
          idx: imgGallery.length,
          src: $(this).data('original') ? $(this).data('original') : ($(this).data('src') ? $(this).data('src') : $(this).prop('src')),
          alt: $(this).prop('alt'),
          title: $(this).prop('title'),
          description: $(this).data('description'),
          caption: $(this).data('caption') ? $(this).data('caption') : $(this).parent().children('figcaption').html(),
        });

        $(this)
          .parent()
          .click(function (e) {
            if (!vmg.images || !vmg.images.length) {
              vmg.images = imgGallery;
            }
            for (var i = 0; i < vmg.images.length; i++) {
              var actualImage = e.target.dataset.original ? e.target.dataset.original : e.target.src;
              if (actualImage == vmg.images[i].src) {
                vmg.selected = vmg.images[i];
                break;
              }
            }
            $("#imagesGallery").foundation("open");
          });
      }
    });
  }
});

Vue.component("gallery", {
  props: ["selected"],
  template: "#gallery-template",
  methods: {
    next: function () {
      vmg.next();
    },
    prev: function () {
      vmg.prev();
    }
  }
});

Vue.component("gallerycaption", {
  props: ["selected", "count", "title"],
  template: "#gallery-caption-template"
});

Vue.component("gallerysmall", {
  props: ["image", "idx"],
  template: "#gallery-small-template"
});
if ($("#vue-gallery").length) {
  vmg = new Vue({
    el: "#vue-gallery",
    data: {
      images: [],
      selected: {}
    },
    methods: {
      next: function () {
        if (this.selected.idx == this.images.length - 1) {
          this.selected = this.images[0];
        } else {
          this.selected = this.images[this.selected.idx + 1];
        }
      },
      prev: function () {
        if (this.selected.idx == 0) {
          this.selected = this.images[this.images.length - 1];
        } else {
          this.selected = this.images[this.selected.idx - 1];
        }
      }
    }
  });
}
$(document).keydown(function (e) {
  if (e.keyCode == 37) {
    vmg.prev();
  }

  if (e.keyCode == 39) {
    vmg.next();
  }
});